import { supabase } from '../supabaseClient';

const uniquePermutations = (digits) => {
  const results = new Set();
  const permute = (arr, current) => {
    if (arr.length === 0) {
      results.add(current);
      return;
    }
    for (let i = 0; i < arr.length; i++) {
      const next = arr.slice(0, i).concat(arr.slice(i + 1));
      permute(next, current + arr[i]);
    }
  };
  permute(digits, '');
  return Array.from(results);
};

const pad3 = (n) => String(n).padStart(3, '0');

const buildCandidates = (takenCode) => {
  const digits = takenCode.split('');
  const ordered = [];
  const seen = new Set([takenCode]);
  const push = (code) => {
    if (!/^\d{3}$/.test(code)) return;
    if (seen.has(code)) return;
    seen.add(code);
    ordered.push(code);
  };

  // Tier 1 : permutations des chiffres saisis
  uniquePermutations(digits).forEach(push);

  // Tier 2 : pair fallback (garder 2 chiffres, varier le 3e à chaque position)
  for (let pos = 0; pos < 3; pos++) {
    for (let d = 0; d <= 9; d++) {
      const arr = [...digits];
      arr[pos] = String(d);
      push(arr.join(''));
    }
  }

  // Tier 3 : tous les autres codes 000-999, mélangés (dernier recours)
  const randomPool = [];
  for (let n = 0; n < 1000; n++) {
    const code = pad3(n);
    if (!seen.has(code)) randomPool.push(code);
  }
  for (let i = randomPool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [randomPool[i], randomPool[j]] = [randomPool[j], randomPool[i]];
  }
  randomPool.forEach(push);

  return ordered;
};

export async function fetchAvailableSuggestions(takenCode, limit = 3) {
  if (!/^\d{3}$/.test(takenCode || '')) return [];
  const candidates = buildCandidates(takenCode);

  const batchSize = 50;
  const available = [];
  for (let i = 0; i < candidates.length && available.length < limit; i += batchSize) {
    const batch = candidates.slice(i, i + batchSize);
    const { data, error } = await supabase
      .from('admin_Profile')
      .select('referred_by_code')
      .in('referred_by_code', batch);
    if (error) return available;
    const taken = new Set((data || []).map(r => String(r.referred_by_code)));
    for (const code of batch) {
      if (!taken.has(code)) {
        available.push(code);
        if (available.length >= limit) break;
      }
    }
  }
  return available;
}
